import type {
  ReactElement,
  ReactNode,
} from 'react';
import styled from 'styled-components';
import type {
  TagPresetType,
} from '@n3/css-base';

import { Breadcrumbs } from '../Breadcrumbs';
import type {
  BreadcrumbType,
} from '../Breadcrumbs';
import { PageTitle } from '../PageTitle';

const StyledWrapper = styled.div(({
  theme: {
    indents,
  },
}) => ({
  paddingBottom: indents.INDENT_8,
}));

const StyledBreadcrumbsWrapper = styled.div(({
  theme: {
    indents,
  },
}) => ({
  marginBottom: indents.INDENT_7,
}));

export const StyledHeaderBlockWrapper = styled.div(({
  theme: {
    indents,
  },
}) => ({
  marginBottom: indents.INDENT_6,
}));

export type ShowLayoutProps = {
  /**
   * Массив объектов хлебных крошек
   */
  breadcrumbs: BreadcrumbType[];
  /**
   * Заголовок страницы
   */
  title: ReactNode;
  /**
   * Статус
   */
  status?: ReactNode;
  /**
   * Цвет тэга статуса
   */
  statusColor?: TagPresetType;
  /**
   * Блок, выводящийся между заголовком страницы и содержимым
   */
  headerBlock?: ReactNode;
  /**
   * Содержимое страницы
   */
  children?: ReactNode;
};

export function ShowLayout({
  breadcrumbs,
  title,
  status = undefined,
  statusColor = undefined,
  headerBlock = undefined,
  children = undefined,
}: ShowLayoutProps): ReactElement {
  return (
    <StyledWrapper>
      <StyledBreadcrumbsWrapper>
        <Breadcrumbs
          breadcrumbs={breadcrumbs}
        />
      </StyledBreadcrumbsWrapper>

      <PageTitle
        pageType="form"
        status={status}
        statusColor={statusColor}
      >
        {title}
      </PageTitle>

      {
        headerBlock && (
          <StyledHeaderBlockWrapper>
            {headerBlock}
          </StyledHeaderBlockWrapper>
        )
      }

      {children}
    </StyledWrapper>
  );
}
